import forms from "./forms";
import buttons from "./buttons";
import nut from "./nut";
import channel from "./channel";
import dict from "./dict";
import term from "./term";
import group from "./group";
import article from "./article";
import utilities from "./utilities";
import blog from "./blog";
import setting from "./setting";
import auth from "./auth";
import course from "./course";
import message from "./message";
import label from "./label";
import error from "./error";

const items = {
  "columns.library.title": "藏经阁",
  "columns.library.home.title": "首页",
  "columns.library.community.title": "社区",
  "columns.library.palicanon.title": "圣典",
  "columns.library.course.title": "课程",
  "columns.library.term.title": "术语百科",
  "columns.library.dict.title": "字典",
  "columns.library.anthology.title": "文集",
  "columns.library.help.title": "帮助",
  "columns.library.more.title": "更多",
  "columns.library.calendar.title": "佛历",
  "columns.library.convertor.title": "巴利字符转换器",
  "columns.library.palihandbook.title": "语法手册",
  "columns.library.statistics.title": "单词统计",
  "columns.library.blog.label": "个人空间",
  "columns.studio.title": "译经楼",
  "columns.studio.palicanon.title": "圣典",
  "columns.studio.recent.title": "最近编辑",
  "columns.studio.channel.title": "版本风格",
  "columns.studio.group.title": "群组",
  "columns.studio.userdict.title": "用户字典",
  "columns.studio.term.title": "术语",
  "columns.studio.course.title": "课程",
  "columns.studio.article.title": "文章",
  "columns.studio.anthology.title": "文集",
  "columns.studio.analysis.title": "分析",
  "columns.studio.collaboration.title": "协作",
  "columns.studio.basic.title": "常用",
  "columns.studio.advance.title": "高级",
  "columns.studio.setting.title": "设置",
  "columns.exp.title": "经验",
  "columns.studio.invite.title": "注册邀请",
  "columns.studio.transfer.title": "转让",
  "columns.studio.attachment.title": "网盘",
  "columns.studio.tag.title": "标签",
  ...buttons,
  ...forms,
  ...nut,
  ...channel,
  ...dict,
  ...term,
  ...group,
  ...article,
  ...utilities,
  ...blog,
  ...setting,
  ...auth,
  ...course,
  ...message,
  ...label,
  ...error,
};

export default items;
